export const rtoLocations = [
  { label: "TN01 — Chennai (Central) — Ayanavaram", value: "TN-01" },
  { label: "TN02 — Chennai (North West) — Anna Nagar", value: "TN-02" },
  { label: "TN03 — Chennai (North East) — Tondiarpet", value: "TN-03" },
  { label: "TN04 — Chennai (East) — Basin Bridge / Royapuram", value: "TN-04" },
  { label: "TN05 — Chennai (North) — Vyasarpadi / Kolathur", value: "TN-05" },
  { label: "TN06 — Chennai (South East) — Mandaveli", value: "TN-06" },
  { label: "TN07 — Chennai (South) — Adyar / Thiruvanmiyur", value: "TN-07" },
  { label: "TN09 — Chennai (West) — K. K. Nagar", value: "TN-09" },
  {
    label: "TN10 — Chennai (South West) — Virugambakkam / Valasarawakkam",
    value: "TN-10",
  },
  { label: "TN11 — Tambaram", value: "TN-11" },
  { label: "TN12 — Poonamallee", value: "TN-12" },
  { label: "TN13 — Ambattur", value: "TN-13" },
  { label: "TN14 — Sholinganallur", value: "TN-14" },
  { label: "TN15 — Ulundurpet", value: "TN-15" },
  {
    label: "TN15MA — Kallakurichi (special/multiple series)",
    value: "TN-15MA",
  },
  { label: "TN16 — Tindivanam", value: "TN-16" },
  { label: "TN18 — Red Hills (includes Gummidipoondi U.O.)", value: "TN-18" },
  {
    label:
      "TN19 — Chengalpattu (with Thirukazhukundram U.O., Madurantagam U.O.)",
    value: "TN-19",
  },
  { label: "TN20 — Tiruvallur (includes Thiruthani U.O.)", value: "TN-20" },
  { label: "TN21 — Kanchipuram", value: "TN-21" },
  { label: "TN22 — Meenambakkam / Alandur (Meenambakkam RTO)", value: "TN-22" },
  { label: "TN23 — Vellore (includes Gudiyatham U.O.)", value: "TN-23" },
  { label: "TN24 — Krishnagiri", value: "TN-24" },
  { label: "TN25 — Tiruvannamalai", value: "TN-25" },
  {
    label: "TN28 — Namakkal (Namakkal / Namakkal North entries)",
    value: "TN-28",
  },
  {
    label: "TN29 — Dharmapuri (with Palacode U.O., Harur U.O.)",
    value: "TN-29",
  },
  { label: "TN30 — Salem (West) (plus Omalur U.O.)", value: "TN-30" },
  {
    label: "TN31 — Cuddalore (plus Panruti U.O., Neyveli U.O.)",
    value: "TN-31",
  },
  { label: "TN32 — Villupuram", value: "TN-32" },
  { label: "TN33 — Erode", value: "TN-33" },
  {
    label: "TN34 — Namakkal (alternate series / Namakkal North)",
    value: "TN-34",
  },
  { label: "TN36 — Bhavani (Erode region series)", value: "TN-36" },
  { label: "TN37 — Coimbatore (North / Central series)", value: "TN-37" },
  { label: "TN38 — Coimbatore (additional series)", value: "TN-38" },
  { label: "TN39 — Tiruppur", value: "TN-39" },
  { label: "TN40 — Mettupalayam", value: "TN-40" },
  { label: "TN41 — Kulittalai", value: "TN-41" },
  {
    label: "TN42 — Tirupur (additional / south/north variants)",
    value: "TN-42",
  },
  { label: "TN43 — Udagamandalam / Ooty", value: "TN-43" },
  { label: "TN45 — Tiruchirappalli (West)", value: "TN-45" },
  { label: "TN47 — Karur", value: "TN-47" },
  {
    label:
      "TN48 — Srirangam / Tiruchirapalli East (and variants TN48Z/TN48Y/TN48X)",
    value: "TN-48",
  },
  { label: "TN49 — Thanjavur (and Pattukottai U.O.)", value: "TN-49" },
  {
    label: "TN50 — Tiruvarur (includes Mannargudi, Thiruthuraipoondi U.O.)",
    value: "TN-50",
  },
  { label: "TN51 — Nagapattinam", value: "TN-51" },
  { label: "TN52 — Salem (S) / Sangagiri series", value: "TN-52" },
  { label: "TN54 — Salem (E)", value: "TN-54" },
  {
    label: "TN55 — Pudukottai (plus Aranthangi, Illupur, Alangudi U.O. series)",
    value: "TN-55",
  },
  { label: "TN56 — Erode (additional series)", value: "TN-56" },
  { label: "TN57 — Dindigul (multiple sub-series)", value: "TN-57" },
  { label: "TN58 — Madurai (South series)", value: "TN-58" },
  { label: "TN59 — Madurai (North / Central series)", value: "TN-59" },
  { label: "TN60 — Periyakulam (Theni region)", value: "TN-60" },
  { label: "TN61 — Ariyalur", value: "TN-61" },
  { label: "TN63 — Sivaganga", value: "TN-63" },
  { label: "TN64 — Madurai (additional series)", value: "TN-64" },
  { label: "TN65 — Ramanathapuram", value: "TN-65" },
  { label: "TN66 — Coimbatore (extra series)", value: "TN-66" },
  { label: "TN67 — Virudhunagar", value: "TN-67" },
  { label: "TN68 — Kumbakonam", value: "TN-68" },
  { label: "TN69 — Kovilpatti (also TN96 used in region)", value: "TN-69" },
  { label: "TN70 — Hosur (Krishnagiri / Hosur region)", value: "TN-70" },
  { label: "TN72 — Tirunelveli", value: "TN-72" },
  { label: "TN73 — Ranipet (and Arakkonam U.O.)", value: "TN-73" },
  { label: "TN74 — Nagercoil (Kanyakumari region)", value: "TN-74" },
  { label: "TN75 — Kanyakumari", value: "TN-75" },
  {
    label: "TN76 — Ambasamudram (Tirunelveli / Tenkasi region)",
    value: "TN-76",
  },
  {
    label: "TN77 — Attur (Salem region — includes Vazhapadi U.O.)",
    value: "TN-77",
  },
  {
    label:
      "TN78 — Dharapuram (Tiruppur region; includes Udumalpet series TN78MA)",
    value: "TN-78",
  },
  { label: "TN79 — Sankarankovil", value: "TN-79" },
  {
    label: "TN81 — Tiruchirapalli East / Tiruverumbur (and variants)",
    value: "TN-81",
  },
  { label: "TN82 — Mayiladuthurai (and Sirkali U.O.)", value: "TN-82" },
  {
    label: "TN83 — Tirupattur (and Ambur / Vaniyambadi / Ambur U.O. series)",
    value: "TN-83",
  },
  { label: "TN84 — Srivilliputhur", value: "TN-84" },
  { label: "TN85 — Kundrathur", value: "TN-85" },
  { label: "TN86 — Erode West", value: "TN-86" },
  { label: "TN87 — Sriperumbudur", value: "TN-87" },
  { label: "TN90 — Salem (South)", value: "TN-90" },
  {
    label: "TN91 — Chidambaram (and Virudhachalam U.O. variants)",
    value: "TN-91",
  },
  { label: "TN92 — Thiruchendur", value: "TN-92" },
  { label: "TN93 — Mettur", value: "TN-93" },
  { label: "TN94 — Palani", value: "TN-94" },
  { label: "TN95 — Sivakasi", value: "TN-95" },
  {
    label: "TN96 — (used by Kovilpatti region in some series)",
    value: "TN-96",
  },
  {
    label:
      "TN97 — Arani / Arani U.O. (and Cheyyar U.O. appears as TN97z in official listing)",
    value: "TN-97",
  },
  {
    label:
      "PY05 — PUDUCHERRY",
    value: "PY-05",
  },
  { label: "TN99 — Coimbatore (additional series)", value: "TN-99" },
];

export const nomineeRelations = [
  { label: "Spouse", value: "spouse" },
  { label: "Son", value: "son" },
  { label: "Daughter", value: "daughter" },
  { label: "Father", value: "father" },
  { label: "Mother", value: "mother" },
  { label: "Brother", value: "brother" },
  { label: "Sister", value: "sister" },
  { label: "Other", value: "other" },
];

export const relianceNomineeRelations = [
  { label: "Mother", value: "mother" },
  { label: "Spouse", value: "spouse" },
  { label: "Son", value: "son" },
  { label: "Legal Heir", value: "legal heir" },
  { label: "Daughter", value: "daughter" },
  { label: "Others", value: "others" },
  { label: "Father", value: "father" },
];

export const nationalNomineeRelations = [
  { label: "Self", value: "self" },
  { label: "Husband", value: "husband" },
  { label: "Son", value: "son" },
  { label: "Father", value: "father" },
  { label: "Father In Law", value: "father in law" },
  { label: "Wife", value: "wife" },
  { label: "Daughter", value: "daughter" },
  { label: "Sister", value: "sister" },
  { label: "Brother", value: "brother" },
  { label: "Mother", value: "mother" },
  { label: "Mother in Law", value: "mother in law" },
];

// KSHEMA's portal offers a shorter, role-based list rather than the
// per-relative lists above — "Child"/"Parent" instead of Son/Daughter and
// Father/Mother, plus "Policyholder" for a self-nomination.
/**
 * The nominee relations Brisk's certificate takes — the exact set its own page offers (RayalBrokers-backend/shared/briskV2Rules.js,
 * the automation's briskCertificate.js BRISK_RELATIONS). Used when PA is bought from Brisk on a policy sold by two insurers or
 * TP only; every one of them is also on National's list, so a National TP accepts the same pick.
 */
export const briskNomineeRelations = [
  { label: "Father", value: "father" },
  { label: "Mother", value: "mother" },
  { label: "Wife", value: "wife" },
  { label: "Husband", value: "husband" },
  { label: "Sister", value: "sister" },
  { label: "Son", value: "son" },
  { label: "Daughter", value: "daughter" },
  { label: "Brother", value: "brother" },
];

export const kshemaNomineeRelations = [
  { label: "Spouse", value: "spouse" },
  { label: "Common Law", value: "common law" },
  { label: "Child", value: "child" },
  { label: "Parent", value: "parent" },
  { label: "Other", value: "other" },
  { label: "Policyholder", value: "policyholder" },
];

// KSHEMA only. The portal asks whether the nominee is a person or a company;
// no other insurer here makes that distinction.
export const nomineeTypeOptions = [
  { label: "Individual", value: "individual" },
  { label: "Corporate", value: "corporate" },
];

export const genderOptions = [
  { label: "Male", value: "male" },
  { label: "Female", value: "female" },
  { label: "Other", value: "other" },
];

// Reliance's Title list for a person (utils/proposerTitle.js); the value is what the portal's <select> holds. Its M/S (the
// company title) is not offered: Reliance refuses it for an individual customer (removed 2026-10-16, the owner's call).
export const titleOptions = [
  { label: "Mr.", value: "Mr." },
  { label: "Ms.", value: "Ms." },
  { label: "Mrs.", value: "Mrs." },
];

export const stateOptions = [
  { label: "Tamil Nadu", value: "tamilnadu" },
  { label: "Pondicherry", value: "pondicherry" },
  { label: "Karnataka", value: "karnataka" },
  { label: "Kerala", value: "kerala" },
  { label: "Maharashtra", value: "maharashtra" },
  { label: "Delhi", value: "delhi" },
  { label: "Gujarat", value: "gujarat" },
  { label: "Rajasthan", value: "rajasthan" },
  { label: "West Bengal", value: "westbengal" },
  { label: "Andhra Pradesh", value: "andhrapradesh" },
  { label: "Telangana", value: "telangana" },
];
